var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.container !== null)?_c('div',[_c('b-modal',{staticClass:"container-tracking-modal",attrs:{"id":_vm.container.container_number,"hide-footer":"","title":_vm.$t('invoices.tracking.modal.title', {
        containerNumber: _vm.container.container_number
      })}},_vm._l((_vm.events),function(event,i){return _c('div',{key:i,staticClass:"update-status tracking-dots",class:{
        disabled: event.time.precision === 'expected',
        completed: event.time.precision === 'actual',
        active: _vm.activeClass(event, i)
      }},[_c('div',{staticClass:"event-location"},[_vm._v(" "+_vm._s(event.location)+" ")]),_c('div',{staticClass:"event-time"},[_vm._v(" "+_vm._s(_vm._f("moment")(event.time.time,'MMM, DD, YYYY'))+" ")]),_c('div',{staticClass:"event-status"},[_vm._v(" "+_vm._s(event.status)+" ")])])}),0)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }